var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6C0.5 2.96243 2.96243 0.5 6 0.5H16C19.0376 0.5 21.5 2.96243 21.5 6V7.93548C21.5 10.9731 19.0376 13.4355 16 13.4355H11.026C10.0643 13.4355 9.16075 13.8959 8.5955 14.6738L8 15.4935L7.4045 14.6738C6.83925 13.8959 5.93571 13.4355 4.97405 13.4355H4.1404C2.12986 13.4355 0.5 11.8056 0.5 9.79509V6Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.dc59598fae3487458f89a0020cc5adae.svg";
export { ForwardRef as ReactComponent };